export default function useUpdate() {
  const camera = useCamera()
  const renderer = useRenderer()
  const raycaster = useRaycaster()

  function update() {
    camera.update()
    renderer.update()
    // First we need to render, then update points
    // (otherwise there is a weird lag effect and points are on old frame position)
    raycaster.update()
  }

  return {
    update,
  }
}
